import { call, put, takeLatest } from "redux-saga/effects";
import { onGetCardMasterData, onGetCardMasterSuccess, onGetCardMasterDataError, onGetCardMasterDataReset, onGetCardMasterError } from "../Store/Slices/cardMasterSlice";
import { callCardMasterGetApi } from "../Context/cardMasterApi";

function* GetCardMaster({ payload }) {
  try {
    const getCardMasterResponse = yield call(callCardMasterGetApi, payload);
    if (getCardMasterResponse.httpStatusCode === "200") {
      yield put(
        onGetCardMasterSuccess({
          data: getCardMasterResponse.response,
          message: getCardMasterResponse.errorMessage,
          status_code: getCardMasterResponse.httpStatusCode
        })
      );
    } else {
      yield put(
        onGetCardMasterError({
          data: getCardMasterResponse.response,
          message: getCardMasterResponse.response.message,
          status_code: getCardMasterResponse.httpStatusCode
        })
      );
    }
  } catch (error) {
    const message = error.response.data.errorMessage || "Something went wrong";
    yield put(onGetCardMasterError({ data: [], message, status_code: 400 }));
  }
}


export default function* cardMasterSaga() {
  yield takeLatest(onGetCardMasterData.type, GetCardMaster);
}
